import React, { useEffect, useRef, useState } from "react";
import { useGetProductsQuery } from "../../store/api/productsApi";
import {
  useCreateMovementMutation,
  useCreateProductOrderMutation,
  useGetLastGenIdQuery,
} from "../../store/api/movementApi";
import { useGetSuppliersQuery } from "../../store/api/supplierApi";
import { useGetNotificationsQuery } from "../../store/api/notificationApi";
import Swal from "sweetalert2";
import { useGetLastRequestGenIdQuery } from "../../store/api/RequestedMaterialsApi";
import Logo from "../tools/Logo";
import PDFMaterialReturningGenerator from "../tools/PDFMaterialReturningGenerator";
import { useGetUnitsQuery } from "../../store/api/UnitsApi";
import Select from "react-select";
import { useGetConsumerQuery } from "../../store/api/consumerApi";
import { useDrafts } from "../tools/useDrafts";

const initialFormData = {
  productName: "",
  Name: "",
  ProductsId: "",
  OrderQty: 1,
  quantity: 1,
  supplierId: null,
  consumerId: null,
  UnitesId: "",
  UnitName: "",
  OrderPurpose: "",
  OrderType: "",
  amount: 0,
};

export default function MaterialReturning() {
  const { drafts, handleUpdateDraft, handleRemoveDraft } =
    useDrafts("materialReturning");

  const { refetch: refetchNotifications } = useGetNotificationsQuery();
  // Fetch Business
  const [Units, setUnitsList] = useState([]);
  const [isSaved, setSaved] = useState(false);
  const [suppId, setSupplierId] = useState(null);
  const [Description, setDescription] = useState("");
  const [issueType, setIssueType] = useState("");
  const [Name, setName] = useState("");

  const [consumers, setConsumers] = useState([]);
  const { data: UnitsList } = useGetUnitsQuery();
  useEffect(() => {
    if (UnitsList) {
      setUnitsList(UnitsList);
    }
  }, [UnitsList]);

  const [shouldExcludeLastRow, setShouldExcludeLastRow] = useState(false);
  let [getLastRequestGendId, setGetLastRequestGendId] = useState([]);
  const [createProductOrders] = useCreateProductOrderMutation();
  const [createMovement] = useCreateMovementMutation();
  const [filteredSupplier, setFilterSupplier] = useState([]);
  let [getLastId, setGetLastId] = useState(null);
  const [products, setProducts] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [seletectedProductQty, setSeletectedProductQty] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [formData, setFormData] = useState(initialFormData);
  const [DateIssue, setDateIssue] = useState("");
  const [formDataList, setFormDataList] = useState([]);
  const initializedRef = useRef(false);

  const { data: product, refetch: refetchProducts } = useGetProductsQuery({
    refetchOnMountOrArgChange: true,
  });
  useEffect(() => {
    if (product) {
      setProducts(product);
    }
  }, [product]);

  useEffect(() => {
    if (drafts && drafts.length > 0 && !initializedRef.current) {
      setDescription(drafts.at(0)?.Description);
      if (drafts.at(0)?.OrderType === "ToSupplier") {
        setSupplierId(drafts.at(0)?.supplierId);
      } else {
        setSupplierId(drafts.at(0)?.consumerId);
      }
      setIssueType(drafts.at(0)?.OrderType);
      if (drafts.at(0)?.OrderType === "ToSupplier") {
        setFormData({
          ...formData,
          supplierId: drafts.at(0)?.supplierId,
          Name: drafts.at(0)?.Name,
          OrderType: drafts.at(0)?.OrderType,
          OrderPurpose: drafts.at(0)?.OrderPurpose,
          consumerName: drafts.at(0)?.consumerName,
          OrderDate: drafts.at(0)?.OrderDate,
        });
      } else {
        setFormData({
          ...formData,
          consumerId: drafts.at(0)?.consumerId,
          Name: drafts.at(0)?.Name,
          OrderType: drafts.at(0)?.OrderType,
          OrderPurpose: drafts.at(0)?.OrderPurpose,
          consumerName: drafts.at(0)?.consumerName,
          OrderDate: drafts.at(0)?.OrderDate,
        });
      }
      setFormDataList([...drafts]);
      setSaved(true);

      initializedRef.current = true;
    }
  }, [drafts, getLastId]);

  const { data: supplier } = useGetSuppliersQuery({
    refetchOnMountOrArgChange: true,
  });
  useEffect(() => {
    if (supplier) {
      setSuppliers(supplier);
    }
  }, [supplier]);

  const { data: lastId, refetch: refetchLastId } = useGetLastGenIdQuery();

  useEffect(() => {
    if (lastId) {
      setGetLastId(lastId);
    }
  }, [lastId]);

  const { data: consumer } = useGetConsumerQuery({
    refetchOnMountOrArgChange: true,
  });
  useEffect(() => {
    if (consumer) {
      setConsumers(consumer);
    }
  }, [consumer]);

  const productOptions = products
    ?.filter((pro) => pro.isActive === "active" && pro.qty > 0)
    .map((pro) => ({
      value: pro.id,
      label: pro.name,
    }));

  const { data: lastRequestId } = useGetLastRequestGenIdQuery({
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (lastRequestId) {
      setGetLastRequestGendId(lastRequestId);
    }
  }, [lastRequestId]);

  const handleSelectChange = (Option) => {
    setSelectedOption(Option);

    if (Option != null) {
      const selectedProductId = parseInt(Option.value);
      const selectedProduct = products.find(
        (product) => product.id === selectedProductId
      );
      const selectedProductAmount = selectedProduct.amount;
      const selectedProductUnitesId = selectedProduct.unitesId;
      const selectedUnit = Units.find(
        (unit) => unit.id === selectedProductUnitesId
      );
      var selectedProductQty = selectedProduct.qty;
      setSeletectedProductQty(selectedProductQty);
      setFormData({
        ...formData,
        ProductsId: selectedProductId,
        productName: selectedProduct.name,
        UnitesId: selectedProductUnitesId,
        UnitName: selectedUnit.name,
        supplierId: issueType === "ToSupplier" ? suppId : null,
        consumerId: issueType !== "ToSupplier" ? suppId : null,
        amount: selectedProductAmount,
      });
    }
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    if (name === "OrderPurpose") {
      setDescription(value);
    }

    if (name === "OrderDate") {
      setDateIssue(value);
    }

    if (name === "OrderType") {
      setFormData({
        ...formData,
        [name]: value,
        supplierId: null,
        consumerId: null,
        OrderPurpose: "",
      });
      setIssueType(value);
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSupplierSelectChange = (name, selected) => {
    setSupplierId(null);
    if (selected != "No Supplier") {
      const selectedSupplierId = parseFloat(selected);

      const filteredSuppliers = suppliers.filter((supplier) => {
        return supplier.id === selectedSupplierId;
      });

      const supplierOptions = filteredSuppliers.map((supplier) => ({
        value: supplier.id,
        label: supplier.name,
      }));

      console.log(supplierOptions);

      if (supplierOptions.length > 0) {
        setName(supplierOptions[0].label);
        setSupplierId(supplierOptions[0].value);
      }

      setFormData({
        ...formData,
        [name]: selected,
        supplierId: supplierOptions.length > 0 ? supplierOptions[0].value : "",
        Name: supplierOptions.length > 0 ? supplierOptions[0].label : "",
        consumerId: null,
        OrderPurpose: "",
      });
    }
  };

  const handleConsumerSelectChange = (name, selected) => {
    setSupplierId(null);
    if (selected != "Select Consumer") {
      const selectConsumerId = parseInt(selected);
      const selectedConsumer = consumers.find(
        (con) => con.id === selectConsumerId
      );
      setSupplierId(selectConsumerId);
      setName(selectedConsumer.name);
      setFormData({
        ...formData,
        [name]: selectConsumerId,
        Name: selectedConsumer.name,
        supplierId: null,
        OrderPurpose: "",
      });
    }
  };

  function getGreatestId(ids) {
    console.log(ids);

    let maxNumericPart = -Infinity;
    let maxFullId = null;

    ids.forEach((id) => {
      if (id) {
        const parts = id.split("-");
        const numericPart = parseInt(parts[parts.length - 1], 10);

        if (!isNaN(numericPart) && numericPart > maxNumericPart) {
          maxNumericPart = numericPart;
          maxFullId = id;
        }
      }
    });

    // Check if both IDs were null or undefined
    if (ids.every((id) => id === null || id === undefined)) {
      return null;
    }

    return maxFullId;
  }

  const handleAddToList = async (e) => {
    e.preventDefault();
    setSelectedOption(null);
    setSaved(true);
    const isProductExists = formDataList.some(
      (data) => data.productName === formData.productName
    );

    if (isProductExists) {
      //Swal.fire('This product is already in your list. Please remove it to add more quantity.')
      updateQuantities(formDataList, formData);
    } else if (Object.values(formData).some((value) => value === "")) {
      console.log(formData);

      Swal.fire({
        title: "Please fill in all fields 📥.",
        showClass: {
          popup: `
            animate__animated
            animate__fadeInUp
            animate__faster
          `,
        },
        hideClass: {
          popup: `
            animate__animated
            animate__fadeOutDown
            animate__faster
          `,
        },
      });
    } else {
      if (formData.OrderQty <= 0) {
        Swal.fire("Invalid Quantity");
      } else {
        if (issueType === "ToSupplier") {
          setFormDataList([
            ...formDataList,
            {
              ...formData,
              supplierId: suppId,
              Description: Description,
              OrderType: issueType,
            },
          ]);
          handleUpdateDraft("OrderQty", {
            ...formData,
            supplierId: suppId,
            Description: Description,
            OrderType: issueType,
          });
          setFormData({
            productName: "",
            Name: Name,
            productId: null,
            OrderQty: 1,
            consumerId: null,
            supplierId: suppId,
            OrderPurpose: Description,
            OrderType: issueType,
            OrderDate: DateIssue,
            amount: 0,
          });
        } else {
          setFormDataList([
            ...formDataList,
            {
              ...formData,
              consumerId: suppId,
              OrderPurpose: Description,
              OrderType: issueType,
            },
          ]);
          handleUpdateDraft("OrderQty", {
            ...formData,
            consumerId: suppId,
            OrderPurpose: Description,
            OrderType: issueType,
          });
          setFormData({
            productName: "",
            Name: Name,
            productId: null,
            OrderQty: 1,
            consumerId: suppId,
            supplierId: null,
            OrderPurpose: Description,
            OrderType: issueType,
            OrderDate: DateIssue,
            amount: 0,
          });
        }
      }
    }
  };

  const updateQuantities = (formDataList, formData) => {
    const oldProduct = formDataList.filter(
      (data) => data.productName === formData.productName
    );

    console.log(seletectedProductQty, " ==== ", oldProduct.at(0).OrderQty);

    if (
      seletectedProductQty <
      parseInt(oldProduct.at(0).OrderQty) + parseInt(formData.OrderQty)
    ) {
      Swal.fire("insufficient Quantity");
    } else {
      oldProduct.at(0).OrderQty =
        parseInt(oldProduct.at(0).OrderQty) + parseInt(formData.OrderQty);
      const oldFormDataList = formDataList.filter(
        (data) => data.productName !== formData.productName
      );
      setFormDataList([...oldFormDataList, ...oldProduct]);
      handleUpdateDraft("OrderQty", { ...formData });
      if (issueType === "ToSupplier") {
        setFormData({
          productName: "",
          Name: "",
          productId: null,
          OrderQty: 1,
          consumerId: null,
          supplierId: suppId,
          OrderPurpose: Description,
          OrderType: issueType,
          amount: 0,
        });
      } else {
        setFormData({
          productName: "",
          Name: "",
          productId: null,
          OrderQty: 1,
          consumerId: suppId,
          supplierId: null,
          OrderPurpose: Description,
          OrderType: issueType,
          amount: 0,
        });
      }
    }
  };

  const handleRemove = (e, row) => {
    e.preventDefault();
    handleRemoveDraft(row.ProductsId);
    const newData = formDataList.filter((item) => item !== row);
    if (newData.length > 0) {
      setFormDataList(newData);
    } else {
      setFormDataList([]);
      setFormData(initialFormData);
      setSaved(false);
    }
  };

  const formatDate = () => {
    const date = new Date();
    return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
  };

  // function generateUniqueId() {
  //   const timestamp = new Date().getTime()
  //   const year = new Date()
  //   const random = Math.floor(Math.random() * 1000) // Generate a random number between 0 and 999
  //   return `${timestamp + year.getFullYear()}-${random}`
  // }

  const generateUniqueId = (name, length, getLastIds) => {
    let lastNumber = 100;
    let randomString = "";
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

    if (getLastId) {
      if (getLastIds && getLastIds.trim() !== "") {
        const index = getLastIds.lastIndexOf("-");
        const lastPart = getLastIds.substring(index + 1);

        lastNumber = parseInt(lastPart, 10);
        if (!isNaN(lastNumber)) {
          lastNumber++;
        }
      }
    }

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      randomString += chars[randomIndex];
    }
    let gen = `${name}-${randomString}-${lastNumber}`;
    return gen;
  };

  const createProductOrder = async () => {
    var data = formDataList?.length > 0 ? formDataList[0] : {};
    const userData = JSON.parse(localStorage.getItem("UserData"));
    const userId = userData ? userData.id : null;
    const generateId = generateUniqueId(
      "PLM",
      6,
      getGreatestId([getLastId?.genId, getLastRequestGendId?.genId])
    );

    const orderData = {
      Id: 0,
      consumerId: data.consumerId,
      supplierId: data.supplierId,
      orderType: issueType,
      GenId: generateId,
      OrderDate: data.OrderDate,
      UsersId: userId,
    };

    const savedOrderData = await createProductOrders(orderData);

    return savedOrderData;
  };

  // const RestData = () => {
  //   setSeletectedProductQty(null);
  //   localStorage.removeItem('materialReturning');
  //   setFormDataList([]);
  //   setFormData(initialFormData);
  //   setSaved(false)
  // }

  const RestData = (e, type) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} the selected material details !!!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#022B3A",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then((result) => {
      if (result.isConfirmed) {
        setSeletectedProductQty(null);
        localStorage.removeItem("materialReturning");
        setFormDataList([]);
        setFormData(initialFormData);
        setSaved(false);
      }
    });
  };

  const handlCreateMaterialReturning = async (type, event) => {
    event.preventDefault();
    setSaved(false);
    setShouldExcludeLastRow(!shouldExcludeLastRow);
    let allSuccess = true;
    let msg = "";
    // const generateId = generateUniqueId("PLM", 6, getGreatestId([getLastId?.genId, getLastRequestGendId?.genId]));

    const productOrderResponse = await createProductOrder();

    if (productOrderResponse.data.status === 200) {
      for (const item of formDataList) {
        const movementResponse = await createMovement({
          ...item,
          GenId: productOrderResponse.data.orders?.genId,
          ProductOrderId: productOrderResponse.data.orders?.id,
        });
        if (movementResponse.data.status !== 200) {
          allSuccess = false;
          msg = movementResponse.data.message;
          break;
        } else {
          msg = movementResponse.data.message;
        }
      }

      await refetchNotifications();
      await refetchLastId();

      if (allSuccess) {
        if (type === "download") {
          PDFMaterialReturningGenerator(
            productOrderResponse.data.orders?.genId,
            formDataList
          );
        }
        setFormDataList([]);
        setShouldExcludeLastRow(!shouldExcludeLastRow);

        Swal.fire({
          title: "Success!",
          text: msg,
          icon: "success",
          confirmButtonText: "Done",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: msg,
          icon: "error",
          confirmButtonText: "Close",
        });
      }
    }

    setSeletectedProductQty(null);
    localStorage.removeItem("materialReturning");
    setFormDataList([]);
    setFormData(initialFormData);
    setSaved(false);
    await refetchProducts();
  };

  const ConfirmHandle = async (type, event) => {
    event.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} this request details !!!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#022B3A",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then((result) => {
      if (result.isConfirmed) {
        handlCreateMaterialReturning(type, event);
      }
    });
  };

  const allFieldsFilled = [
    formData.ProductsId,
    formData.OrderQty,
    formData.OrderType,
    formData.UnitesId,
    formData.OrderPurpose,
  ].every(Boolean);

  const eitherSupplierOrConsumer =
    formData.supplierId != null || formData.consumerId != null;

  const canSave = allFieldsFilled && eitherSupplierOrConsumer;

  const createPage = () => {
    if (formDataList.length === 0) {
      return (
        <div className="text-center fs-4 text-muted mt-5">
          Invoice goes here
        </div>
      );
    }

    const startIndex = 0;
    // const endIndex = Math.min(8, formDataList.length)
    const endIndex = formDataList.length;
    const pageData = formDataList.slice(startIndex, endIndex);

    return (
      <div
        className="d-flex flex-column justify-content-start position-relative "
        style={{
          height: "21cm",
        }}
      >
        <div className="text-left ">
          <div className="row">
            <div className="col-12 mt-1 mb-3">
              <h4 className="text-start font-size-h6">Product List</h4>
            </div>
          </div>
        </div>

        <div className="table-responsive1">
          <table className="table table-striped">
            <thead className="table-dark p-0">
              <tr>
                <th className="text-lowercase text-center">Name</th>
                <th className="text-lowercase text-center">Quantity</th>
                <th className="font-size-h6 text-center">Unit</th>
                <th className="text-lowercase text-center">Purpose</th>
                <th className="text-lowercase text-center">Price</th>
                <th className="text-lowercase text-center">Total</th>
                <th className={shouldExcludeLastRow ? "d-none" : "text-center"}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {pageData.map((item, index) => (
                <>
                  <tr key={index}>
                    <td className="text-center">{item.productName}</td>
                    <td className="text-center">{item.OrderQty}</td>
                    <td className="text-center">{item.UnitName}</td>
                    <td className="text-center">
                      {item.OrderPurpose.length > 10
                        ? `${item.OrderPurpose.slice(0, 10)}...`
                        : item.OrderPurpose}
                    </td>

                    <td className="text-center">${item.amount}</td>
                    <td className="text-center">
                      ${item.amount * item.OrderQty}
                    </td>

                    <td
                      className={
                        shouldExcludeLastRow ? "d-none" : "text-center"
                      }
                    >
                      <button
                        className={
                          shouldExcludeLastRow
                            ? "d-none"
                            : "btn bg-danger text-white"
                        }
                        onClick={(e) => handleRemove(e, item)}
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                </>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="block m-2 p-md-4">
        <div className="row border-bottom">
          <div className="col-lg-4 col-md-6 col-sm-3 col-12 mb-2 fs-3">
            Material Returining
          </div>
        </div>
        <form>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-12">
              <div className="row mt-4">
                <div className="col-md-12 mt-2">
                  <div className="mb-3">
                    <div className="row">
                      <label
                        htmlFor="SelectIssueType"
                        className="form-label text-start"
                      >
                        Returining Issue Type
                      </label>
                    </div>
                    <select
                      disabled={isSaved}
                      name="OrderType"
                      className="form-select"
                      style={{ height: "45px" }}
                      aria-label="Default select example"
                      id="SelectIssueType"
                      onChange={handleFormChange}
                      value={
                        formData.OrderType === ""
                          ? "Select Issue Type"
                          : formData.OrderType
                      }
                    >
                      <option selected>Select Issue Type</option>
                      <option value={"ToSupplier"}>Return to Supplier</option>
                      <option value={"ToStock"}>Returning to stock</option>
                    </select>
                  </div>
                </div>

                {formData.OrderType && formData.OrderType === "ToSupplier" ? (
                  <div className="mt-2">
                    <div className="mb-3">
                      <div className="row">
                        <label
                          htmlFor="SelectSupplier"
                          className="form-label text-start"
                        >
                          Suppliers
                        </label>
                      </div>
                      <select
                        disabled={isSaved}
                        className="form-control"
                        style={{ height: "45px" }}
                        aria-label="Default select example"
                        id="SelectSupplier"
                        onChange={(e) =>
                          handleSupplierSelectChange(
                            "supplierId",
                            e.target.value
                          )
                        }
                        value={
                          formData.supplierId === null
                            ? "Select Supplier"
                            : formData.supplierId
                        }
                      >
                        <option selected>No Supplier</option>
                        {suppliers?.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                ) : (
                  <div className="mt-2">
                    <div className="mb-3">
                      <div className="row">
                        <label
                          htmlFor="SelectFaculty"
                          className="form-label text-start"
                        >
                          Who Returns These Products?
                        </label>
                      </div>
                      <select
                        disabled={isSaved}
                        className="form-select"
                        style={{ height: "45px" }}
                        aria-label="Default select example"
                        id="SelectFaculty"
                        onChange={(e) =>
                          handleConsumerSelectChange(
                            "consumerId",
                            e.target.value
                          )
                        }
                        value={
                          formData.consumerId === null
                            ? "Select Consumer"
                            : formData.consumerId
                        }
                      >
                        <option selected>Select Consumer</option>
                        {consumers?.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
                <div className="mt-2">
                  <div className="row">
                    <label
                      htmlFor="notificationQuantity"
                      className="form-label text-start"
                    >
                      Purpose?
                    </label>
                  </div>
                  <textarea
                    disabled={isSaved}
                    className="form-control "
                    name="OrderPurpose"
                    placeholder={formData.OrderPurpose}
                    value={formData.OrderPurpose}
                    onChange={handleFormChange}
                  />
                </div>

                <div className="col-sm-12">
                  <div className="mt-2">
                    <div className="row">
                      <label
                        htmlFor="exampleDateOfBirth"
                        className="form-label text-start"
                      >
                        Date Returning
                      </label>
                    </div>
                    <input
                      disabled={isSaved}
                      style={{ height: "45px" }}
                      name="OrderDate"
                      type="datetime-local"
                      className="form-control"
                      id="exampleDateOfBirth"
                      max={new Date().toISOString().slice(0, 16)}
                      value={formData.OrderDate}
                      autoComplete="off"
                      onChange={handleFormChange}
                    />
                  </div>
                </div>

                <div className="mt-2">
                  <div className="mb-3">
                    <div className="row">
                      <label
                        htmlFor="SelectProduct"
                        className="form-label text-start"
                      >
                        Products{" "}
                        {seletectedProductQty > 0 ? (
                          <span className={"text-primary fs-6 mx-2"}>
                            The selected product quantity is{" "}
                            {seletectedProductQty}
                          </span>
                        ) : (
                          ""
                        )}
                      </label>
                    </div>

                    <div className="d-flex mb-3">
                      <div className="input-group flex-grow-1 me-2">
                        <Select
                          className="w-100"
                          name="ProductsId"
                          inputId="SelectProduct"
                          options={productOptions}
                          onChange={handleSelectChange}
                          value={selectedOption}
                          placeholder="Select Product"
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              height: "40px", // Match the height with the other input
                              minHeight: "40px",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 9999,
                            }),
                          }}
                        />
                      </div>
                      <div className="input-group" style={{ width: "150px" }}>
                        <select
                          disabled={true}
                          className="form-control"
                          style={{ height: "40px" }}
                          aria-label="Default select example"
                          id="SelectUnits"
                          name="UnitesId"
                          onChange={handleFormChange}
                          value={formData.UnitesId || 0}
                        >
                          <option value={0}>Units</option>
                          {Units.map((data) => (
                            <option key={data.id} value={data.id}>
                              {data.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-12 mt-2">
                  <div className="row">
                    <label
                      htmlFor="notificationQuantity"
                      className="form-label text-start"
                    >
                      How many quantity{" "}
                      <span className="text-lowercase">
                        {" "}
                        {formDataList && formDataList.length > 0
                          ? formDataList.at(0).OrderType === "ToSupplier"
                            ? "would you like to " +
                              formDataList
                                .at(0)
                                .OrderType.replace(/([A-Z])/g, " $1")
                                .trim()
                            : "he / she wants to" +
                              formData.OrderType.replace(
                                /([A-Z])/g,
                                " $1"
                              ).trim()
                          : formData && formData.OrderType === "ToSupplier"
                          ? "would you like to " +
                            formData.OrderType.replace(/([A-Z])/g, " $1").trim()
                          : "he / she wants to " +
                            formData.OrderType.replace(
                              /([A-Z])/g,
                              " $1"
                            ).trim()}
                      </span>{" "}
                      ?
                    </label>
                  </div>
                  <div className="input-group">
                    <input
                      name="OrderQty"
                      style={{ height: "45px" }}
                      type="number"
                      min={1}
                      className="form-control numericInput"
                      id="notificationQuantity"
                      value={formData.OrderQty}
                      onChange={handleFormChange}
                    />
                  </div>
                </div>

                <div className="text-end ">
                  <button
                    disabled={!canSave}
                    type="button"
                    className="btn btn-primary mt-2 px-3 pe-3 pt-2 pb-2 mt-3 mb-sm-5"
                    onClick={handleAddToList}
                  >
                    Add To The List
                  </button>
                </div>
              </div>
            </div>

            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-8 col-12">
              <div className="mt-3 mb-3">
                {formDataList.length > 0 ? (
                  <div className="d-flex justify-content-end">
                    <div className="me-2">
                      <button
                        title="Clear"
                        onClick={(e) => RestData(e, "Clear")}
                        className="btn btn-secondary p-2"
                      >
                        <Logo
                          _width={25}
                          name={"../image/icons/clear-01.svg"}
                          _height={25}
                          _color={"#FFFFFF"}
                        />
                      </button>
                    </div>
                    <div className="me-2">
                      <button
                        title="Download"
                        type="submit"
                        onClick={(e) => ConfirmHandle("download", e)}
                        className="btn btn-secondary p-2"
                      >
                        <Logo
                          _width={25}
                          name={"../image/icons/download.svg"}
                          _height={25}
                          _color={"#FFFFFF"}
                        />
                      </button>
                    </div>

                    <div className="me-3">
                      <button
                        title="Save"
                        type="submit"
                        onClick={(e) => ConfirmHandle("save", e)}
                        className="btn btn-success p-2"
                      >
                        <Logo
                          _width={25}
                          name={"../image/icons/save.svg"}
                          _height={25}
                          _color={"#FFFFFF"}
                        />
                      </button>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>

              <div className="position-relative">{createPage()}</div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
